<script>
export default {
  methods: {
    checkPermission (permission) {
      const scopes = this.$store.getters['session/scopes']

      if (scopes) {
        if (typeof permission === 'string') {
          return scopes.includes(permission)
        } else {
          return permission.every(p => scopes.includes(p))
        }
      }

      this.$store.watch(
        (state, getters) => getters['session/scopes'], () => { this.checkPermission(permission) }
      )
    }
  }
}
</script>
